import { Pipe, PipeTransform } from '@angular/core';
import { ProductCode } from '@mkp/shared/models';
import { getPerformanceKey } from '@mkp/shared/models';
@Pipe({
  name: 'performanceReachPipe',
  pure: true,
})
export class PerformanceReachPipe implements PipeTransform {
  transform(code: ProductCode): string {
    return getPerformanceKey(code);
  }
}
